import { connect } from 'react-redux'
import Settings from './components/Settings/Settings'

const mapDispatchToProps = dispatch => ({
    dispatch
})

export default connect((state) => ({ onboard: state.onboard }), mapDispatchToProps)(Settings)
